module.exports = __webpack_public_path__ + "cc68087a724724dfc1560f21c74452eb.jpg";